import { Loader2 } from "lucide-react";

export function RefreshingIndicator({ visible, label = "Refreshing..." }: { visible: boolean; label?: string }) {
  if (!visible) return null;
  return (
    <div className="inline-flex items-center gap-1.5 text-xs text-muted-foreground">
      <Loader2 className="h-3.5 w-3.5 animate-spin" />
      <span>{label}</span>
    </div>
  );
}
